/**
 * TKP-122 — periyodik görev: saf yardımcılar (store/Vue yok).
 * Görev formunda periyot seçilirse kayıt tanım olarak açılır (`/periodic-task`), ilk görev sunucuda hemen üretilir;
 * seçilmezse bugünkü görev yolu birebir (TKP-121 `savePlan`).
 */
import { assigneesOf } from "./bulk-assign";

export const PERIODS = ["WEEKLY", "MONTHLY", "QUARTERLY", "HALF_YEARLY", "YEARLY"];
const id = (v) => String((v && v._id) || v || "");

/** Seçici seçenekleri: "Yok" + dönemler (etiketler `task.periodic.periods.<KEY>`). */
export const periodOptions = (t) => [{ value: "", label: t("task.periodic.none") }, ...PERIODS.map((p) => ({ value: p, label: t(`task.periodic.periods.${p}`) }))];
export const periodLabel = (period, t) => (PERIODS.includes(period) ? t(`task.periodic.periods.${period}`) : period || "");

/** Yeni kayıt (`_id` yok) ve geçerli bir periyot seçilmişse periyodik tanım yolu. */
export const isPeriodicForm = (form) => !!form && !form._id && PERIODS.includes(form.period);

/** `/periodic-task` gövdesi: metinler, atananlar (kimlik), öncelik, kategori, ürünler, periyot, ilk son tarih (gün sayısı sunucuda). */
export const definitionPayload = (form) => {
  const { _id, assignees: _a, assignee: _b, taskRelations: _r, status: _s, ...rest } = form || {};
  return {
    ...rest,
    assignees: assigneesOf(form).map((a) => ({ _id: id(a), name: a.name })),
    category: form && form.category ? { _id: id(form.category) } : undefined,
    period: form.period,
  };
};

/** Açılış sonucunun kullanıcı mesajı: kaç görev üretildi, kaç atanan atlandı. */
export const periodicResultMessage = (response, t) => {
  const result = (response && response.result) || {};
  const parts = [t("task.periodic.created", { count: result.created || 0 })];
  if (result.skipped) parts.push(t("task.periodic.skipped", { count: result.skipped }));
  return { text: parts.join(" "), variant: result.skipped ? "warning" : "success" };
};

/** Liste satırı: tarihleri ve atanan adlarını ekrana hazırlar. */
export const definitionRow = (definition, t, formatDate = (d) => d) => ({
  ...definition,
  periodLabel: periodLabel(definition.period, t),
  assigneeNames: (definition.assignees || []).map((a) => (a && a.name) || id(a)).join(", "),
  nextRunLabel: definition.active && definition.nextRunAt ? formatDate(definition.nextRunAt) : "—",
  lastRunLabel: definition.lastRunAt ? formatDate(definition.lastRunAt) : "—",
});
